import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind CSS classes with conflict resolution.
 *
 * Combines clsx (conditional classes) with tailwind-merge
 * (resolves conflicting Tailwind utilities, last class wins).
 *
 * @example
 * cn('px-4 py-2', 'bg-blue-500', isActive && 'bg-blue-700')
 * // => 'px-4 py-2 bg-blue-700' (when isActive is true)
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
